/**
 * Removes all non numeric chars from a string.
 */
export function getOnlyDigits(value: string): string {
  return value.replace(/[^0-9]/g, '');
}
